import { expect, Page } from "@playwright/test";
import {
    getFilterButton,
    getFilterTags,
} from "../utils/stateful-overview-utils";

export const testApplyFilters = async (page: Page) => {
    const filterButton = getFilterButton(page);
    await expect(filterButton).toBeVisible();
    await expect(filterButton.getByText("Filter")).toBeVisible();
    await expect(filterButton.getByText("2")).toHaveCount(0);

    // Sidebar should open
    const sidebar = page.locator("ux-sidebar").first();
    await expect(sidebar.locator("ux-sidebar-content")).not.toBeInViewport();
    await filterButton.click();
    await expect(sidebar.locator("ux-sidebar-content")).toBeInViewport();

    // Check checkboxes
    await expect(sidebar.locator("ux-checkbox")).toHaveCount(4);
    await sidebar.locator("ux-checkbox").nth(0).click();
    await sidebar.locator("ux-checkbox").nth(3).click();
    await expect(
        sidebar.locator("ux-checkbox").nth(0).locator("input")
    ).toBeChecked();
    await expect(
        sidebar.locator("ux-checkbox").nth(3).locator("input")
    ).toBeChecked();

    // Display filter tags
    await sidebar.locator("ux-button").first().click();
    // await expect(sidebar.locator("ux-sidebar-content")).not.toBeVisible();
    await expect(filterButton.getByText("2")).toBeVisible();
    await expect(getFilterTags(page).locator(".ux-tag")).toHaveCount(2);
    await expect(
        getFilterTags(page).getByText("Reset all filters")
    ).toBeVisible();
};
